import React from 'react';
import styled from 'styled-components';
import { Trans, useTranslation } from "react-i18next";
const StyledPayoff = styled.h1 `
  font-size: 30px;
  color: white;
  font-family: ${props => props.theme.fontHead};
  margin: 30px 0;
  text-align: center;
  
  @media only screen and (min-width: 992px) {
    position: absolute;
    left: ${props => (props.variant ? "auto" : "15px")};
    top: ${props => (props.variant ? "auto" : "50%")};
    right: ${props => (props.variant ? "15px" : "auto")};
    bottom: ${props => (props.variant ? "0" : "auto")};
    transform: translateY(-50%);
    font-size: 28px;
    margin: 0;
    text-align: left;
    max-width: 240px;
  }

    @media only screen and (min-width: 991px) {
      right: ${props => (props.variant ? "20px" : "auto")};
      font-size: 38px;
    }
    
    @media only screen and (min-width: 1200px) {
      left: ${props => (props.variant ? "auto" : "80px")};
      right: ${props => (props.variant ? "90px" : "auto")};
    }
  }
`;
const Payoff = ({ variant }) => {
    const { t } = useTranslation();
    return (React.createElement(StyledPayoff, { variant: variant },
        React.createElement(Trans, { i18nKey: "payoff", components: { emphasize: React.createElement("span", null) }, values: { app_name: t("app_name") } })));
};
export default Payoff;
